import { DefaultButton, Dialog, DialogContent, DialogFooter, DialogType, IDialogContentProps, PrimaryButton, Spinner, SpinnerSize, TextField } from "@fluentui/react";
import React from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLazyStopInstanceQuery } from "../../../src/taskpane/components/_v2/redux/api/nintex/api-nintex-slice";
import { useLazyGetItemByUniqueIDQuery, useLazySendSharepointItemToRecyclebinQuery } from "../../../src/taskpane/components/_v2/redux/api/sharepoint/api-sharepoint-slice";
import { RootState } from "../../../src/taskpane/components/_v2/redux/storeMain";
import { setLastApprovalLoad } from "../../../src/taskpane/redux/modules/approvals";
import authModule from "../../../utilities/AuthModule";
import { LanguageContext } from "../../../utilities/LocalizationModule";
import { logger } from "../../../utilities/logger";

const dialogStyles = { main: { maxWidth: 450 } };

export interface ICMDeleteModalProps {
    showDialog: boolean;
    closeDialog: () => void;
    closeOnSuccess: (hasError: boolean) => void;
    selectedItem: any;
}

export const CMCancelAssignmentModal = ({ showDialog, closeDialog, closeOnSuccess, selectedItem }: ICMDeleteModalProps) => {
    const languageStrings = React.useContext(LanguageContext);

    const currentDirectory = useSelector((state: RootState) => state.workingDirectories?.workingDirectories.length > 0 ? state.workingDirectories?.workingDirectories[state.workingDirectories?.workingDirectories?.length - 1] : null);
    const nintexClientId = useSelector((state: RootState) => state.tenantInfo.nintexClientId);
    const nintexClientSecret = useSelector((state: RootState) => state.tenantInfo.nintexClientSecret);

    const [isBusy, setIsBusy] = React.useState(false);
    const [reason, setReason] = React.useState("");

    const [stopInstance] = useLazyStopInstanceQuery();
    const [getItemByUniqueId] = useLazyGetItemByUniqueIDQuery();
    const [sendSharepointItemToRecyclebin] = useLazySendSharepointItemToRecyclebinQuery();

    const dialogContentProps: IDialogContentProps = {
        type: DialogType.normal,
        title: languageStrings.CancelAssignment,
        subText: languageStrings.CancelAssignmentConfrimMessage,
        showCloseButton: true,
        closeButtonAriaLabel: 'Close'
    };

    const onConfirmCancel = async () => {
        setIsBusy(true);

        let hasError = false;
        const spAccessToken = await authModule.getSharePointAccessToken();

        try {
            const file = await getItemByUniqueId({
                siteUrl: currentDirectory.webUrl,
                sharePointListId: currentDirectory.sharePointListId,
                uniqueId: selectedItem.UniqueId?.replace("{", "").replace("}", ""),
                accessToken: spAccessToken,
            }).unwrap();

            if (file) {
                const stopInstanceResults = await stopInstance({
                    instanceId: file.NtxInstanceId,
                    reason,
                    accessToken: await authModule.getNintexAccessToken(nintexClientId, nintexClientSecret),
                }).unwrap();

                if (stopInstanceResults.status.toLowerCase() === 'ok') {
                    try {
                        await sendSharepointItemToRecyclebin({
                            siteUrl: currentDirectory.webUrl,
                            sharePointListId: currentDirectory.sharePointListId,
                            accessToken: spAccessToken,
                            itemId: file.ID
                        }).unwrap();
                    } catch (error) {
                        hasError = true;
                    }
                    
                    closeOnSuccess(hasError);
                }
            }
        } catch (error) {
            hasError = true;
            logger(error, "CMCancelAssignmentModal.tsx (onConfirmCancel)");
        }
    }

    return (
        <Dialog hidden={!showDialog} onDismiss={() => closeDialog()} dialogContentProps={dialogContentProps} >
            <TextField autoFocus multiline={true} rows={3} value={reason} onChange={(e, newValue) => setReason(newValue)} label={languageStrings.Reason}/>
            <DialogFooter>
                <PrimaryButton onClick={() => onConfirmCancel()} text={languageStrings.Yes} disabled={isBusy}>
                    {isBusy && <Spinner size={SpinnerSize.small} style={{ paddingLeft: '5px' }} />}
                </PrimaryButton>
                <DefaultButton onClick={() => closeDialog()} text={languageStrings.No} disabled={isBusy} />
            </DialogFooter>
        </Dialog>
    )
};